"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoTargetToJSON = exports.GeoTargetFromJSONTyped = exports.GeoTargetFromJSON = exports.instanceOfGeoTarget = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the GeoTarget interface.
 */
function instanceOfGeoTarget(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGeoTarget = instanceOfGeoTarget;
function GeoTargetFromJSON(json) {
    return GeoTargetFromJSONTyped(json, false);
}
exports.GeoTargetFromJSON = GeoTargetFromJSON;
function GeoTargetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'countryCode': !(0, runtime_1.exists)(json, 'country_code') ? undefined : json['country_code'],
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : json['type'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'parentGeoName': !(0, runtime_1.exists)(json, 'parent_geo_name') ? undefined : json['parent_geo_name'],
    };
}
exports.GeoTargetFromJSONTyped = GeoTargetFromJSONTyped;
function GeoTargetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'country_code': value.countryCode,
        'id': value.id,
        'type': value.type,
        'name': value.name,
        'parent_geo_name': value.parentGeoName,
    };
}
exports.GeoTargetToJSON = GeoTargetToJSON;
